._footerWrapper_1buqh_1 {
  text-align: center;
  padding-top: 6px; }

._footerWrapper_1buqh_1 ._arrow_1buqh_5 {
  vertical-align: middle;
  margin-left: 6px;
  width: 4px;
  height: 7px;
  margin-top: 2px;
  stroke: none;
  fill: none;
  stroke-width: 1px; }

._footerWrapper_1buqh_1 ._arrow_1buqh_5 path {
  fill: none;
  stroke: #3899ec; }
